import { Messages } from '../../codegen/Localize';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IRemoteRefreshPropertiesInfo } from '../models/IRemoteRefreshPropertiesInfo';
import { IExtractItemInfo } from '../models/resourceInfoParts';
import { RemoteRefreshTypes } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';

export module RefreshPropertyHelper {

  export function getAvailableRefreshTypes(item: IExtractItemInfo): string[] {
    const types: string[] = [];
    types.push(RemoteRefreshTypes.Full);

    if (item.hasIncrementalExtract) {
      types.push(RemoteRefreshTypes.Incremental);
    }

    return types;
  }

  export function canBeRefreshedRemotely(datasource: IDataSourceBase): boolean {
    // To be refreshed remotely (on a sync client) the datasource must have an extract and not be OAuth.
    return datasource.hasExtracts &&
      !(datasource.connectionOAuth &&
        datasource.connectionDetails &&
        datasource.connectionDetails.type === 'database');
  }

  export function getCurrentRefreshLocation(refreshed: IRemoteRefreshPropertiesInfo): string {
    if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && refreshed.remoteAgentName) {
      return refreshed.remoteAgentName;
    } else if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && refreshed.remoteAgentReservationId) {
      return Messages.remoteRefreshModeReservedLabel();
    } else if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && !refreshed.remoteAgentName) {
      return Messages.remoteRefreshModeUnlinkedLabel();
    } else {
      return Messages.remoteRefreshModeServerLabel();
    }
  }

  // Prevent deep links to the incorrect refresh schedules page
  // 'extractTasks' is the default state
  export function redirectByDatasourceRefreshMode($state: ng.ui.IStateService, refreshMode: string): void {
    // Don't assume the refresh mode property is defined. If it isn't 'extractTasks' is the default state.
    if (($state.is('main.site.content.datasource.remoteRefreshSchedules') || $state.is('main.site.content.datasource.publishresult'))
        && refreshMode !== RefreshModeTypes.Remote) {
      $state.go('^.extractTasks');
      return;
    }

    if (($state.is('main.site.content.datasource.extractTasks') || $state.is('main.site.content.datasource.publishresult'))
        && refreshMode === RefreshModeTypes.Remote) {
      $state.go('^.remoteRefreshSchedules');
      return;
    }
  }
}
